import React, {useEffect, useState} from 'react';
import {Link, useParams} from "react-router-dom";
import {useSelector} from "react-redux";
import axios from "axios";

const DetailSDS = () => {

    const {id} = useParams()
    const userLogin = useSelector(state => state.userLogin)
    const {userInfo} = userLogin

    const [sds, setSDS] = useState('')

    const getSingleSDS = async () => {
        const {data} = await axios.get(`https://homesafetysolutions.pythonanywhere.com/api/sds/${id}/`, {
            // const {data} = await axios.get(`http://127.0.0.1:8000/api/sds/${id}/`, {
            headers: {
                'Content-type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`
            }
        })
        setSDS(data)
        // console.log(data)
    }

    useEffect(() => {
        getSingleSDS()
    }, [])

    return (
        <div>
            <div className={"banner_heading"}>
                <h1>SDS Details: </h1>
                <div>
                    <p>SDS Name: {sds.sds_name}</p>
                    <p>SDS Manufacturer: {sds.manufacturer}</p>
                    <p>SDS Revision Date: {sds.revision_date}</p>
                    {/*<p>Link to the <a href={`https://homesafetysolutions.pythonanywhere.com${sds.sds_document}`}> {sds.sds_name} SDS PDF</a></p>*/}
                    <p>Link to the <a href={`http://127.0.0.1:8000${sds.sds_document}`}> {sds.sds_name} SDS PDF</a></p>
                    <br />
                    <Link className={'btn btn-primary'} to={`/sds/update/${sds.id}/`}>Update SDS</Link>
                </div>
            </div>
        </div>
    );
};

export default DetailSDS;

// import React from 'react';
//
// const DetailSDS = (props) => (
//
// );
//
// export default DetailSDS;